import type { LimitKey } from "./ai-assistant.logic";
import type { VoiceNumberKey } from "./voice-settings.logic";

export type LimitGroupField = LimitKey | VoiceNumberKey | "kioskUserId";

export interface LimitGroup {
	id: "per-user" | "history" | "kiosk" | "voice" | "ceiling";
	title: string;
	fields: LimitGroupField[];
}

/** Pengelompokan form "Batas pemakaian"; urutan field = urutan tampil. */
export const LIMIT_GROUPS: LimitGroup[] = [
	{
		id: "per-user",
		title: "Per pengguna",
		fields: [
			"ratePerMinutePerUser",
			"dailyMessageLimitPerUser",
			"maxInputChars",
		],
	},
	{
		id: "history",
		title: "Riwayat",
		fields: ["historyWindow", "retentionDays"],
	},
	{
		id: "kiosk",
		title: "Kiosk /wall",
		fields: ["kioskUserId", "dailyMessageLimitKiosk", "guideAutoAdvanceSec"],
	},
	{
		id: "voice",
		title: "Suara",
		fields: [
			"voiceDailyMinutesUser",
			"voiceDailyMinutesKiosk",
			"voiceSessionMaxMinutes",
			"voiceIdleOffSeconds",
		],
	},
	{
		id: "ceiling",
		title: "Plafon AI",
		fields: ["dailyTokenLimitGlobal"],
	},
];

/** Kolom grid seragam untuk semua grup (1 kolom sempit, 2 sedang, 3 desktop). */
export const LIMIT_GRID_COLS = { base: 1, sm: 2, lg: 3 } as const;

/** Urutan bagian: description di bawah input agar kotak input sejajar. */
export const BELOW_INPUT_ORDER = [
	"label",
	"input",
	"description",
	"error",
] as const;
